import { useCallback, useEffect, useRef, useState } from 'react';
import { evaluateRuntimePolicy } from '../runtimePolicy';
export function useWidgetRuntime({ engineRuntime, drawingUiEnabled, drawingActiveTool, selectedDrawingType, onRuntimeResolved, }) {
    const runtimePolicy = evaluateRuntimePolicy({
        engineRuntime,
        drawingUiEnabled,
        drawingActiveTool,
        selectedDrawingType,
    });
    const resolvedRequestedRuntime = runtimePolicy.resolvedRuntime;
    const resolvedRequestedReason = runtimePolicy.reasonCode;
    const lastNotifiedRuntimeResolutionRef = useRef(null);
    const [effectiveRuntime, setEffectiveRuntime] = useState(resolvedRequestedRuntime);
    const [effectiveRuntimeReason, setEffectiveRuntimeReason] = useState(resolvedRequestedReason);
    // Sync state when runtime policy resolves a different target runtime or reason
    const [prevRequestedRuntime, setPrevRequestedRuntime] = useState(resolvedRequestedRuntime);
    const [prevRequestedReason, setPrevRequestedReason] = useState(resolvedRequestedReason);
    if (resolvedRequestedRuntime !== prevRequestedRuntime || resolvedRequestedReason !== prevRequestedReason) {
        setPrevRequestedRuntime(resolvedRequestedRuntime);
        setPrevRequestedReason(resolvedRequestedReason);
        setEffectiveRuntime(resolvedRequestedRuntime);
        setEffectiveRuntimeReason(resolvedRequestedReason);
    }
    useEffect(() => {
        const previous = lastNotifiedRuntimeResolutionRef.current;
        if (previous && previous.runtime === effectiveRuntime && previous.reason === effectiveRuntimeReason) {
            return;
        }
        lastNotifiedRuntimeResolutionRef.current = {
            runtime: effectiveRuntime,
            reason: effectiveRuntimeReason,
        };
        onRuntimeResolved?.(effectiveRuntime, effectiveRuntimeReason);
    }, [effectiveRuntime, effectiveRuntimeReason, onRuntimeResolved]);
    const handleRuntimeDegraded = useCallback((_reason) => {
        // Runtime degradation handling - can be extended for auto-fallback
    }, []);
    const useForkRuntime = effectiveRuntime === 'fork';
    const contentRuntimeKey = `${effectiveRuntime}-${false}`; // showNonTradingDays handled elsewhere
    const runtimeCapabilities = {
        engineRuntime: 'fork',
        forkSupported: useForkRuntime,
        paneToolbar: true,
        paneSplitters: true,
        chartCanvasOverlays: true,
        measurementOverlay: true,
        drawingOverlays: true,
    };
    return {
        useForkRuntime,
        effectiveRuntime,
        runtimeReason: effectiveRuntimeReason,
        runtimeCapabilities,
        contentRuntimeKey,
        handleRuntimeDegraded,
    };
}
